var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpperColored(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 15.75C3.85786 15.75 0.5 12.3921 0.5 8.25C0.5 4.10786 3.85786 0.75 8 0.75C12.1421 0.75 15.5 4.10786 15.5 8.25C15.4955 12.3903 12.1403 15.7455 8 15.75ZM7.988 14.25H8C11.3125 14.2467 13.9957 11.5595 13.994 8.247C13.9923 4.93447 11.3065 2.25 7.994 2.25C4.68146 2.25 1.99566 4.93447 1.994 8.247C1.99234 11.5595 4.67546 14.2467 7.988 14.25ZM5.3855 10.398L4.325 9.3375L8.0375 5.625L11.75 9.3375L10.6895 10.3973L8.0375 7.746L5.38625 10.398H5.3855Z",
    fill: "#49963B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpperColored);
export default __webpack_public_path__ + "static/media/upperColored.e8f0fa4f659a0b9551eaf111a8b3b905.svg";
export { ForwardRef as ReactComponent };